module.exports = __webpack_public_path__ + "static/cannon-93b1bc020cb2111347a6371469872c04.svg";